import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { MyAccountNavbar } from "../../components/MyAccountComponents/MyAccountNavbar"
import { MyServicePanel } from "../../components/MyAccountComponents/MyServicePanel"
import { setAccountNavbarTitle } from "../../store/reducers/AccountNavbarReducer"
import { tryToGetAccountServices } from "../../store/reducers/AccountServicesReducer"

export const MyServicesContainer = () => {

    const dispatch = useDispatch()

    const isNavbarShowed = useSelector( (state: any) => (state.navbar.isNavbarShowed))
    const servicesList = useSelector( (state: any) => (state.accountServices))

    useEffect( () => { 
        dispatch( setAccountNavbarTitle(4             ) )
        dispatch( tryToGetAccountServices() )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div
            className={`my-account-wrapper ${isNavbarShowed ? 'page-with-opened-navbar' : 'page-with-closed-navbar'}`}
        >
            <MyAccountNavbar/>

            <div
                className="my-account-wrapper__finances-wrapper"
            >
                {
                    servicesList
                    &&
                    servicesList.length > 0
                    &&
                    servicesList.map( (elem, index) => (
                        <div key={index}>
                            <MyServicePanel data={elem}/>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}